module.exports = __webpack_public_path__ + "img/27.01dc0242.jpg";